import { IconProps } from '../types/icon';

export const Icon = (props: IconProps) => {
  const { name, color, size, customStyle } = props;

  return <img src={`/icons/${name}-${color}-${size}.svg`} style={customStyle} />;
};
